import Container from "../../layout/Container"
import Navbar from "../../layout/Navbar"
import CartProductCard from "../../components/cards/CartProductCard"

export default () => {
    return(
        <>
            <Navbar gradient />
            <Container>
                    <div className="mt-5 pt-5 container ecomm-cart">
                        <div className="card rounded-4 p-4 mt-5">
                            <h3 className="custom-text-color mb-4">Shoping cart</h3>
                            <div className="row">
                                <div className="col-lg-8 col-md-12 p-0">
                                    <CartProductCard />
                                    <CartProductCard />
                                </div>
                                <div className="col-lg-4 col-md-12 p-0">
                                    <div className="card rounded-4 p-3 m-3">
                                        <h3 className="custom-text-color mb-4">Cart totals</h3>
                                        <div className="d-flex justify-content-between align-items-center custom-text-color">
                                            <div>
                                                <p>Subtotal</p>
                                                <p>Items</p>
                                                <p>Discount</p>
                                                <p>Shipping Fee</p>
                                            </div>
                                            <div>
                                                <p>₹240</p>
                                                <p>2</p>
                                                <p className="text-success">₹200</p>
                                                <p>₹50</p>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className="d-flex justify-content-between align-items-center">
                                            <p className="bold">Total Amount</p>
                                            <p className="bold">₹290</p>
                                        </div>

                                        <button className="search-button py-2">Search</button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </Container>
        </>
    )
}